<template>
  <b-navbar toggleable="lg" type="dark" variant="primary" class="startNavbar">
    <b-container>
      <div class="py-3"></div>
      <!-- <b-navbar-brand to="/">DigiRoll</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="https://digi-roll.de" target="_blank">Das Projekt</b-nav-item>
        </b-navbar-nav> -->

        <!-- Right aligned nav items -->
        <!-- <b-navbar-nav class="ml-auto">
        </b-navbar-nav>
      </b-collapse> -->
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: 'StartNavbar'
}
</script>

<style scoped>

</style>